import { deleteCookie, extractCookie, shouldSetSecureCookie } from 'lib/web/cookieUtils'

/**
 * How long a channel markup v2 session lasts: the session user cookie (`lecmSessionUser`) and the
 * sign-in cookie that pairs with it both expire this long after they are written.
 */
export const CHANNEL_MARKUP_V2_SESSION_MAX_AGE_SECONDS = 7 * 24 * 60 * 60

/**
 * Cookie naming the user who signed in mid-session without changing the channel
 * markup v2 prices. It tells the server to keep the session's prices for that user, instead of
 * re-resolving them from the live account (which a later LuxPlus+ purchase would have changed).
 *
 * It is unsigned on purpose: it can only ask the server to keep the prices the session already
 * has, never to grant different ones.
 */
export const CHANNEL_MARKUP_V2_SIGN_IN_COOKIE_NAME = 'lecmSignInUser'

export function setChannelMarkupV2SignInCookie(userId: string): void {
  document.cookie = `${CHANNEL_MARKUP_V2_SIGN_IN_COOKIE_NAME}=${encodeURIComponent(userId)}; Path=/; Max-Age=${CHANNEL_MARKUP_V2_SESSION_MAX_AGE_SECONDS}; SameSite=Lax${shouldSetSecureCookie() ? '; Secure' : ''}`
}

/**
 * Client-only cookie naming the user the page was last reloaded for after a sign-in that changed
 * the channel markup v2 prices, so it reloads at most once per user. A cookie, not sessionStorage:
 * where sessionStorage is blocked, `isomorphicSessionStorage` falls back to memory, which a reload
 * wipes, so the guard would not survive the reload it guards and the page could reload forever.
 */
export const CHANNEL_MARKUP_V2_SIGN_IN_REFRESH_COOKIE_NAME = 'lecmSignInRefreshUser'

export function getChannelMarkupV2SignInRefreshCookie(): string | undefined {
  return extractCookie(document.cookie, CHANNEL_MARKUP_V2_SIGN_IN_REFRESH_COOKIE_NAME)
}

export function setChannelMarkupV2SignInRefreshCookie(userId: string): void {
  // No Max-Age: a browser-session cookie. It only has to outlive the reload it guards.
  document.cookie = `${CHANNEL_MARKUP_V2_SIGN_IN_REFRESH_COOKIE_NAME}=${encodeURIComponent(userId)}; Path=/; SameSite=Lax${shouldSetSecureCookie() ? '; Secure' : ''}`
}

export function clearChannelMarkupV2SignInRefreshCookie(): void {
  deleteCookie(CHANNEL_MARKUP_V2_SIGN_IN_REFRESH_COOKIE_NAME, '/')
}
